import {useLayoutEffect} from 'react';

import {view} from '@sail/ui/deprecated';
import {
  Input,
  RequestACallConfirmationInline,
  useWidget,
} from '@stripe-internal/conversations-ui';

import {RACTopBar} from './ChatScreen/RACTopBar';

type Props = {
  name: string;
  phoneNumber: string;
  message: string;
};

export const RequestACallConfirmationInlineScreen = ({
  name,
  phoneNumber,
  message,
}: Props) => {
  const {header} = useWidget();

  useLayoutEffect(() => {
    header.setTopBar(<RACTopBar />);
  }, [header]);

  return (
    <view.div
      data-testid="request-a-call-confirmation-inline-screen"
      css={{stack: 'y', height: 'fill'}}
    >
      <view.div css={{padding: 'medium'}}>
        <RequestACallConfirmationInline
          name={name}
          phoneNumber={phoneNumber}
          message={message}
        />
      </view.div>

      <Input
        disabled
        placeholder="How can we help?"
        onSendMessage={async (_) => {}}
        onSendTyping={() => {}}
      />
    </view.div>
  );
};
